import TooltipUI from './TooltipUI';

const DisabledFieldTooltip = ({ disabled, title, children, className = 'w-full' }) => {
  return (
    <TooltipUI
      title={title}
      disableHoverListener={!disabled || !title}
      arrow
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
        tooltip: {
          sx: {
            maxWidth: 900,
          },
        },
      }}
    >
      <div className={className}>{children}</div>
    </TooltipUI>
  );
};

export default DisabledFieldTooltip;
